import type { PhoneNumberSettings } from '../../phoneNumber.types.ts';

const AU_MOBILE_NATIONAL_REGEX = /^04\d{8}$/;

const PHONE_NUMBER: PhoneNumberSettings = {
  country: 'AU',
  defaultPrefix: 'AU+61',
  placeholder: '04XX XXX XXX',
  showCountryPrefix: false,
  formatNationalInput: true,
  nationalNumberRegex: AU_MOBILE_NATIONAL_REGEX,
  nationalTrunkPrefix: '04',
};

export { AU_MOBILE_NATIONAL_REGEX, PHONE_NUMBER };
